import { assert, isDefined } from '@sama/js-core';
import { isUndefined } from 'lodash';
import { ShapeState } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import {
  DeleteShapeLocationOperation,
  ShapeLocationOperationAttributes,
} from '../../../../../team-apis/otterdam/annotation-operations/shape-operations';
import { Output } from '../../../../../team-apis/otterdam/outputs/output';
import { ShapeLocationOperationBuilderParams } from './shape-operation-builder-params';

export function createDeleteShapeLocationBuilders({
  currentShape,
  output,
  locations,
}: ShapeLocationOperationBuilderParams) {
  return locations.map(
    (location) =>
      new DeleteShapeLocationOperationBuilder(
        location.frameNumber,
        output,
        currentShape,
        location.operationAttributes,
      ),
  );
}

// Export is needed to use objects with class type in other files
export class DeleteShapeLocationOperationBuilder {
  constructor(
    private frameNumber: number,
    private output: Output,
    private shapeState?: ShapeState,
    private locationOperationAttributes?: ShapeLocationOperationAttributes,
  ) {}

  canBuild() {
    return (
      isDefined(this.shapeState) &&
      isUndefined(this.locationOperationAttributes)
    );
  }

  build(): DeleteShapeLocationOperation {
    assert(
      this.shapeState,
      'shape should be defined for deleting shape location',
    );
    return buildDeleteShapeLocationOperation(
      this.frameNumber,
      this.shapeState.index,
      this.output.id,
    );
  }
}

export function buildDeleteShapeLocationOperation(
  frameNumber: number,
  shapeId: number,
  outputId: number,
): DeleteShapeLocationOperation {
  return {
    operation: 'DELETE_LOCATION',
    ids: { frameNumber, shapeId },
    outputId,
  };
}
